import React from 'react';
import { Outlet } from 'react-router-dom';
import { Container, Stack } from 'react-bootstrap';
import CompanyProfile from 'components/UserBox/CompanyProfile';

const CompanyBoxLayout: React.FC = () => {
	return (
		<section className="job-seeker-profile py-50">
			<Container fluid>
				<div className="d-flex flex-column flex-xl-row gap-3 gap-xxl-4">
					<div className="left-area d-flex flex-column">
						<div className="user-box white-box bg-white d-none d-xl-block">
							<Stack className="user text-center">
								<CompanyProfile />
							</Stack>
						</div>
					</div>
					<div className="right-area flex-1 d-flex flex-column">
						<Outlet />
					</div>
				</div>
			</Container>
		</section>
	);
};

export default CompanyBoxLayout;
